// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_qL3eX","breadcrumbs":"index_breadcrumbs_ZNDYG"};